<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "PointersOfMonthRouter",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}
</script>